export enum ProgressStagesEnum {
  MERCURY = 'MERCURY',
  VENUS = 'VENUS',
  EARTH = 'EARTH',
  MARS = 'MARS',
  JUPITER = 'JUPITER',
  SATURN = 'SATURN',
  URANUS = 'URANUS',
  NEPTUNE = 'NEPTUNE',
  ANDROMEDA = 'ANDROMEDA',
}

export interface ProgressStageData {
  stage: ProgressStagesEnum;
  numLect: number;
}

export const ProgressSteps: ProgressStageData[] = [
  { stage: ProgressStagesEnum.MERCURY, numLect: 1 },
  { stage: ProgressStagesEnum.VENUS, numLect: 5 },
  { stage: ProgressStagesEnum.EARTH, numLect: 15 },
  { stage: ProgressStagesEnum.MARS, numLect: 33 },
  { stage: ProgressStagesEnum.JUPITER, numLect: 66 },
  { stage: ProgressStagesEnum.SATURN, numLect: 111 },
  { stage: ProgressStagesEnum.URANUS, numLect: 171 },
  { stage: ProgressStagesEnum.NEPTUNE, numLect: 400 },
];

export const ProgressLastStep: ProgressStageData = { stage: ProgressStagesEnum.ANDROMEDA, numLect: Infinity };
